import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'deviceName'
})
export class DeviceNamePipe implements PipeTransform {
  transform(device: any): string {
    return (device.defaultProxy) ? device.defaultProxy.name : device.name;
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/pipes/device-name.pipe.ts